import React, { FC, useEffect } from 'react';
import { Link } from 'react-router5';

import { Button } from '$uikit';
import { useTranslator } from '$hooks';
import { PaymentFailed } from '$shared/components';
import { OTHER } from '$shared/constants/pages';
import { CurrencyEnum } from '$store/models';

export const OnlypayError: FC = () => {
  const t = useTranslator();

  useEffect(() => {
    try {
      window.opener?.postMessage({ type: 'payment_result', status: 'error' }, '*');
    } catch (e) {}
  }, []);

  return (
    <PaymentFailed>
      <Link
        routeName={OTHER}
        routeParams={{ w: 'balance', currency: CurrencyEnum.EUR }}
        onClick={() => {
          try {
            window.parent.postMessage('close_me', '*');
          } catch (e) {}
        }}
      >
        <Button size="small">{t('top_up_failed_go_to_balance')}</Button>
      </Link>
    </PaymentFailed>
  );
};
